import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getAuthErrorMessage, logAuthError } from '../../utils/errorHelpers';

const useAuthSubmit = (isSignUp, userType) => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const {login} = useAuth()

  const onSubmit = async (formState) => {
    if (isSignUp && formState.password !== formState.confirmPassword) {
      setError('Las contraseñas no coinciden. Por favor, verifica que ambas contraseñas sean iguales');
      return;
    }
     
    if(isSignUp && !formState.termsAccepted) {
      setError('Debes aceptar los términos y condiciones para continuar');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/${isSignUp ? 'signup' : 'signin'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          email: formState.email,
          name: formState.name,
          phoneNumber: formState.phoneNumber,
          password: formState.password,
          passwordConfirmation: formState.confirmPassword,
          referralSource: formState.referralSource || null,
          userType,
        }),
        credentials: 'include',
      });

      if (response.ok) {
        const data = await response.json();
        const currentUserType = isSignUp ? userType : data.data?.user?.userType || data.userType;

        await login(data)

        // Check if user is admin by userType
        if (currentUserType === 'admin') {
          navigate('/metricas-dashboard');
        } else if (currentUserType === 'profesionales') {
          navigate('/panel-empleado/perfil-empleado');
        } else if (currentUserType === 'empresas') {
          navigate('/panel-empresa/restaurantes');
        }
      } else {
        const errorData = await response.json();
        logAuthError(response, errorData);
        const errorMessage = getAuthErrorMessage(response.status, errorData);
        setError(errorMessage);
      }
    } catch (error) {
      console.error('Error during authentication:', error);
      setError('Ocurrió un error. Por favor, intenta nuevamente más tarde.');
    }
  };

  return { onSubmit, error };
};

export default useAuthSubmit;
